import React, {Component} from 'react';
import PropTypes from "prop-types";
import ProgressiveImage from "../ProgressiveImage";
import Icon from "../Icon";
import AppLink from "../AppLink";

class VideoContainer extends Component {
  static propTypes = {
    post: PropTypes.object.isRequired,
    imageSize: PropTypes.string,
    section: PropTypes.string
  };

  render() {
    const { post, imageSize, section, tag, layout } = this.props;
    const url = "/video" + (section ? `/${section}` : "/new") + (tag ? `/${tag}/` : "/") + post.slug;

    return (
      <article className={'post-container video-container'}>
        <AppLink to={url} className={'image-wrapper'}>
          <ProgressiveImage image={post.preview} size={imageSize} alt={post.title} />
          <Icon icon={'play'} className={'icon-overlay'} />
        </AppLink>

        {layout === "full" && (
          <div className={'content'}>
            <h3><AppLink to={url}>{post.title}</AppLink></h3>

            <div className={'row'}>
              <div className={'col-6'}>{post.video_info.video_type === "remote" && post.video_info.provider}</div>
              <div className={'col-6 text-right'}><Icon icon={'play'} className={'mr-2'} /> {post.video_info.duration}s</div>
            </div>
          </div>
        )}
      </article>
    );
  }
}

export default VideoContainer;